import { CommodityCondition } from 'store/commodity-conditions-center/commodityCondition';

export type CommodityConditionFormValues = {
    commodityCode: string;
    taricCode: string;
    countryOrigin: string;
    conditionCodes: string[];
};

const toCommodityConditionFormValues = (condition?: CommodityCondition): CommodityConditionFormValues => ({
    commodityCode: condition?.commodityCode ?? '',
    taricCode: condition?.taricCode ?? '',
    countryOrigin: condition?.countryOrigin ?? '',
    conditionCodes: condition?.conditionCodes ?? [],
});

export default toCommodityConditionFormValues;
